import { render } from "./modal-small.vue?vue&type=template&id=3400f82b&scoped=true"
import script from "./modal-small.vue?vue&type=script&lang=js"
export * from "./modal-small.vue?vue&type=script&lang=js"

import "./modal-small.vue?vue&type=style&index=0&id=3400f82b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3400f82b"]])

export default __exports__